import { Controller } from '@hotwired/stimulus';

// Displays flash messages via toastr on connect.
// Works with both full page loads and Turbo navigations.
//
// Usage:
//   <div data-controller="flash"
//        data-flash-messages-value='[{"type":"success","message":"Done!"}]'>
//   </div>
export default class FlashController extends Controller {
  static values = {
    messages: { type: Array, default: [] },
  };

  connect() {
    this.messagesValue.forEach(({ type, message, title }) => {
      const allowedTypes = ['success', 'error', 'warning', 'info'];
      if (allowedTypes.includes(type)) {
        toastr[type](message, title || '', {
          closeButton: true,
          escapeHtml: true,
        });
      }
    });

    // Remove the element after displaying — it's a one-shot container
    this.element.remove();
  }
}
